import React, { useState } from 'react';

import Header from 'components/ui/Header';
import Footer from 'components/ui/Footer';
import WhatsAppButton from 'components/ui/WhatsAppButton';
import Icon from 'components/AppIcon';

import Button from 'components/ui/Button';
import Input from 'components/ui/Input';

const ServiceRequestForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    position: '',
    serviceArea: '',
    urgency: '',
    budget: '',
    message: '',
    preferredContact: '',
    timeline: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Add this block - Helper functions for tracking
  const trackFormSubmission = (formType, data) => {
    // Track form submission with analytics
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'form_submission', {
        form_type: formType,
        ...data
      });
    }
    console.log('Form submission tracked:', formType, data);
  };

  const trackLeadGeneration = (leadType, data) => {
    // Track lead generation with analytics
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'generate_lead', {
        lead_type: leadType,
        ...data
      });
    }
    console.log('Lead generation tracked:', leadType, data);
  };
  // End of added block

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setIsSubmitting(true);

    try {
      // Track form submission
      trackFormSubmission('service_request_form', {
        user_name: formData?.name,
        user_email: formData?.email,
        user_phone: formData?.phone,
        user_company: formData?.company,
        service_type: formData?.serviceType,
        budget_range: formData?.budget
      });

      // Track lead generation
      trackLeadGeneration('service_request', {
        email: formData?.email,
        company: formData?.company,
        name: formData?.name,
        service_type: formData?.serviceType
      });

      // Simulate API call
      setTimeout(() => {
        console.log('Form submitted:', formData);
        setIsSubmitting(false);
        setIsSubmitted(true);
      }, 2000);
    } catch (error) {
      console.error('Form submission error:', error);
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <WhatsAppButton />
        <div className="pt-32 pb-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="bg-white rounded-3xl shadow-xl p-8 lg:p-16">
              <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" style={{backgroundColor: 'rgba(155, 142, 87, 0.1)'}}>
                <Icon name="CheckCircle" size={40} style={{color: '#9B8E57'}} />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Demande Envoyée avec Succès !
              </h1>
              <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
                Votre demande de transformation a été transmise à nos experts CRF PERFECTION. Nous vous contacterons dans les plus brefs délais selon le niveau d'urgence indiqué.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="rounded-lg p-4" style={{backgroundColor: 'rgba(155, 142, 87, 0.1)'}}>
                  <Icon name="Clock" size={24} className="mx-auto mb-2" style={{color: '#96121D'}} />
                  <h3 className="font-semibold text-gray-900 mb-1">Temps de Réponse</h3>
                  <p className="text-sm text-gray-600">Sous 24h ouvrées</p>
                </div>
                
                <div className="rounded-lg p-4" style={{backgroundColor: 'rgba(150, 18, 29, 0.1)'}}>
                  <Icon name="Users" size={24} className="mx-auto mb-2" style={{color: '#9B8E57'}} />
                  <h3 className="font-semibold text-gray-900 mb-1">Expert Dédié</h3>
                  <p className="text-sm text-gray-600">Assignation automatique</p>
                </div>
                
                <div className="rounded-lg p-4" style={{backgroundColor: 'rgba(155, 142, 87, 0.1)'}}>
                  <Icon name="FileText" size={24} className="mx-auto mb-2" style={{color: '#96121D'}} />
                  <h3 className="font-semibold text-gray-900 mb-1">Proposition</h3>
                  <p className="text-sm text-gray-600">Devis personnalisé</p>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  size="lg"
                  className="text-white px-8 py-3 rounded-xl"
                  style={{backgroundColor: '#96121D'}}
                  onClick={() => window.location.href = '/'}
                >
                  Retour à l'Accueil
                </Button>
                
                <Button
                  variant="outline"
                  size="lg"
                  className="px-8 py-3 rounded-xl border-2"
                  style={{borderColor: '#9B8E57', color: '#9B8E57'}}
                  onClick={() => window.open('https://wa.me/12409784155', '_blank')}
                >
                  <div className="flex items-center space-x-2">
                    <Icon name="MessageCircle" size={20} />
                    <span>WhatsApp Direct</span>
                  </div>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <WhatsAppButton />
      
      {/* Hero Section - CRF PERFECTION Branding */}
      <section className="relative overflow-hidden pt-32 pb-20 bg-gradient-to-br from-gray-900 via-[#1a0a0d] to-black">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 right-20 w-64 h-64 rounded-full" style={{background: 'radial-gradient(circle, #96121D 0%, transparent 70%)'}}></div>
          <div className="absolute bottom-20 left-20 w-96 h-96 rounded-full" style={{background: 'radial-gradient(circle, #9B8E57 0%, transparent 70%)'}}></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            {/* Badge */}
            <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full mb-6 border" style={{backgroundColor: 'rgba(150, 18, 29, 0.1)', borderColor: 'rgba(150, 18, 29, 0.3)'}}>
              <Icon name="Sparkles" size={18} style={{color: '#9B8E57'}} />
              <span className="text-sm font-semibold" style={{color: '#9B8E57'}}>Démarrez Votre Transformation</span>
            </div>

            {/* Title */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              Transformez Votre{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r" style={{backgroundImage: 'linear-gradient(to right, #96121D, #9B8E57)'}}>
                Organisation
              </span>
            </h1>

            {/* Subtitle */}
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-8">
              Remplissez ce formulaire détaillé pour recevoir une proposition personnalisée de nos experts en business thérapie et transformation organisationnelle
            </p>

            {/* Quick Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                <div className="text-3xl font-bold mb-1" style={{color: '#9B8E57'}}>8</div>
                <div className="text-sm text-gray-400">Services Experts</div>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                <div className="text-3xl font-bold mb-1" style={{color: '#9B8E57'}}>24h</div>
                <div className="text-sm text-gray-400">Réponse garantie</div>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                <div className="text-3xl font-bold mb-1" style={{color: '#9B8E57'}}>95%</div>
                <div className="text-sm text-gray-400">Taux satisfaction</div>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                <div className="text-3xl font-bold mb-1" style={{color: '#9B8E57'}}>5+</div>
                <div className="text-sm text-gray-400">Années expertise</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Form Section */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        {/* Form Introduction */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Formulaire de Demande Personnalisée
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Plus vous nous fournirez d'informations précises, plus notre proposition sera adaptée à vos besoins spécifiques et à votre contexte organisationnel.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl p-8 lg:p-12">
          <form onSubmit={handleSubmit} className="space-y-8">
            
            {/* Personal & Company Information */}
            <div className="rounded-2xl p-6" style={{backgroundColor: 'rgba(155, 142, 87, 0.05)'}}>
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center space-x-2">
                <Icon name="User" size={24} style={{color: '#96121D'}} />
                <span>Informations Personnelles et Entreprise</span>
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Nom et Prénom *
                  </label>
                  <Input
                    type="text"
                    name="name"
                    value={formData?.name}
                    onChange={handleInputChange}
                    placeholder="Votre nom complet"
                    required
                    className="w-full"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Email Professionnel *
                  </label>
                  <Input
                    type="email"
                    name="email"
                    value={formData?.email}
                    onChange={handleInputChange}
                    placeholder="votre.email@entreprise.com"
                    required
                    className="w-full"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Téléphone *
                  </label>
                  <Input
                    type="tel"
                    name="phone"
                    value={formData?.phone}
                    onChange={handleInputChange}
                    placeholder="+1 (240) 978-4155"
                    required
                    className="w-full"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Entreprise/Organisation *
                  </label>
                  <Input
                    type="text"
                    name="company"
                    value={formData?.company}
                    onChange={handleInputChange}
                    placeholder="Nom de votre entreprise"
                    required
                    className="w-full"
                  />
                </div>
                
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Poste/Fonction *
                  </label>
                  <Input
                    type="text"
                    name="position"
                    value={formData?.position}
                    onChange={handleInputChange}
                    placeholder="Directeur Général, RH, Chef de Projet, etc."
                    required
                    className="w-full"
                  />
                </div>
              </div>
            </div>

            {/* Service Requirements */}
            <div className="rounded-2xl p-6" style={{backgroundColor: 'rgba(150, 18, 29, 0.05)'}}>
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center space-x-2">
                <Icon name="Settings" size={24} style={{color: '#9B8E57'}} />
                <span>Domaine d'Expertise Requis</span>
              </h3>
              
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-3">
                    Quel domaine vous intéresse le plus ? *
                  </label>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {[
                      { value: 'formation-professionnelle', label: 'Formation Professionnelle', icon: 'GraduationCap' },
                      { value: 'conseil-strategique', label: 'Conseil Stratégique', icon: 'Target' },
                      { value: 'business-therapie', label: 'Business Thérapie', icon: 'Heart' },
                      { value: 'etudes-recherches', label: 'Études & Recherches', icon: 'Search' },
                      { value: 'marketing-digital', label: 'Marketing Digital', icon: 'Smartphone' },
                      { value: 'gestion-projets', label: 'Gestion de Projets Digitaux', icon: 'CheckSquare' },
                      { value: 'gestion-rh', label: 'Gestion des Ressources Humaines', icon: 'Users' },
                      { value: 'organisation-conferences', label: 'Organisation de Conférences', icon: 'Calendar' }
                    ]?.map((service) => (
                      <label key={service?.value} className="flex items-center space-x-3 p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-white transition-colors duration-200">
                        <input
                          type="radio"
                          name="serviceArea"
                          value={service?.value}
                          checked={formData?.serviceArea === service?.value}
                          onChange={handleInputChange}
                          className="focus:ring-2"
                          style={{accentColor: '#96121D'}}
                          required
                        />
                        <Icon name={service?.icon} size={20} style={{color: '#96121D'}} />
                        <span className="font-medium text-gray-900">{service?.label}</span>
                      </label>
                    ))}
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-900 mb-2">
                      Niveau d'Urgence *
                    </label>
                    <select
                      name="urgency"
                      value={formData?.urgency}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 bg-white"
                      style={{focusRingColor: '#96121D'}}
                    >
                      <option value="">Sélectionnez le niveau d'urgence</option>
                      <option value="critique">Critique - Intervention immédiate (sous 24h)</option>
                      <option value="urgent">Urgent - Dans la semaine</option>
                      <option value="standard">Standard - Dans le mois</option>
                      <option value="planifie">Planifié - Dans les 3 mois</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-semibold text-gray-900 mb-2">
                      Budget Estimé
                    </label>
                    <select
                      name="budget"
                      value={formData?.budget}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 bg-white"
                    >
                      <option value="">Budget approximatif (optionnel)</option>
                      <option value="moins-5k">Moins de 5 000€</option>
                      <option value="5k-15k">5 000€ - 15 000€</option>
                      <option value="15k-50k">15 000€ - 50 000€</option>
                      <option value="50k-100k">50 000€ - 100 000€</option>
                      <option value="plus-100k">Plus de 100 000€</option>
                      <option value="a-definir">À définir ensemble</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* Project Details */}
            <div className="rounded-2xl p-6" style={{backgroundColor: 'rgba(155, 142, 87, 0.05)'}}>
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center space-x-2">
                <Icon name="FileText" size={24} style={{color: '#96121D'}} />
                <span>Détails du Projet</span>
              </h3>
              
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Décrivez votre situation actuelle et vos objectifs *
                  </label>
                  <textarea
                    name="message"
                    value={formData?.message}
                    onChange={handleInputChange}
                    rows={6}
                    placeholder="Décrivez en détail : 
- Votre situation actuelle et les défis rencontrés
- Vos objectifs à court et moyen terme  
- Les résultats attendus de notre intervention
- Toute information pertinente sur votre organisation..."
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 resize-vertical"
                  />
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-900 mb-2">
                      Moyen de Contact Préféré *
                    </label>
                    <select
                      name="preferredContact"
                      value={formData?.preferredContact}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 bg-white"
                    >
                      <option value="">Choisissez votre préférence</option>
                      <option value="email">Email professionnel</option>
                      <option value="telephone">Appel téléphonique</option>
                      <option value="whatsapp">WhatsApp Business</option>
                      <option value="visioconference">Visioconférence</option>
                      <option value="rdv-physique">Rendez-vous physique</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-semibold text-gray-900 mb-2">
                      Timeline Souhaitée
                    </label>
                    <select
                      name="timeline"
                      value={formData?.timeline}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 bg-white"
                    >
                      <option value="">Quand souhaitez-vous commencer ?</option>
                      <option value="immediat">Immédiatement</option>
                      <option value="1-semaine">Dans la semaine</option>
                      <option value="1-mois">Dans le mois</option>
                      <option value="3-mois">Dans les 3 mois</option>
                      <option value="flexible">Flexible selon vos disponibilités</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* Engagement Information */}
            <div className="border rounded-2xl p-6" style={{backgroundColor: 'rgba(155, 142, 87, 0.05)', borderColor: 'rgba(155, 142, 87, 0.2)'}}>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center space-x-2">
                <Icon name="Info" size={20} style={{color: '#9B8E57'}} />
                <span>Nos Engagements CRF PERFECTION</span>
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <div className="flex items-start space-x-2">
                  <Icon name="CheckCircle" size={16} style={{color: '#96121D'}} className="mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">Réponse garantie sous 24h ouvrées</span>
                </div>
                <div className="flex items-start space-x-2">
                  <Icon name="CheckCircle" size={16} style={{color: '#96121D'}} className="mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">Diagnostic gratuit de 30 minutes</span>
                </div>
                <div className="flex items-start space-x-2">
                  <Icon name="CheckCircle" size={16} style={{color: '#96121D'}} className="mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">Proposition personnalisée sans engagement</span>
                </div>
                <div className="flex items-start space-x-2">
                  <Icon name="CheckCircle" size={16} style={{color: '#96121D'}} className="mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">Confidentialité absolue garantie</span>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="rounded-2xl p-6" style={{backgroundColor: 'rgba(150, 18, 29, 0.05)'}}>
              <div className="text-center">
                <h4 className="text-lg font-bold text-gray-900 mb-4">
                  Prêt à Transformer Votre Organisation ?
                </h4>
                <p className="text-gray-600 mb-6">
                  En envoyant cette demande, vous franchissez le premier pas vers l'excellence organisationnelle avec CRF PERFECTION
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button
                    type="submit"
                    size="xl"
                    disabled={isSubmitting}
                    className="text-white px-12 py-4 rounded-xl font-bold shadow-lg transition-all duration-200 transform hover:scale-105 disabled:opacity-50 disabled:transform-none"
                    style={{background: 'linear-gradient(to right, #96121D, #9B8E57)'}}
                  >
                    <div className="flex items-center justify-center space-x-2">
                      {isSubmitting ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                          <span>Envoi en cours...</span>
                        </>
                      ) : (
                        <>
                          <Icon name="Send" size={20} />
                          <span>Envoyer ma Demande</span>
                        </>
                      )}
                    </div>
                  </Button>
                  
                  <Button
                    type="button"
                    variant="outline"
                    size="xl"
                    className="px-12 py-4 rounded-xl font-bold transition-all duration-200 border-2"
                    style={{borderColor: '#9B8E57', color: '#9B8E57'}}
                    onClick={() => window.location.href = '/contact'}
                  >
                    <div className="flex items-center justify-center space-x-2">
                      <Icon name="ArrowLeft" size={20} />
                      <span>Contact Classique</span>
                    </div>
                  </Button>
                </div>
              </div>
            </div>

          </form>
        </div>

        {/* Additional Information - CRF PERFECTION */}
        <div className="mt-16 rounded-3xl p-8 lg:p-12 text-white relative overflow-hidden" style={{background: 'linear-gradient(135deg, #1a0a0d 0%, #96121D 50%, #9B8E57 100%)'}}>
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full transform translate-x-32 -translate-y-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full transform -translate-x-24 translate-y-24"></div>
          </div>
          
          <div className="relative text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Pourquoi Choisir CRF PERFECTION ?
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name="Award" size={24} className="text-white" />
                </div>
                <h3 className="font-bold mb-2">Expertise Certifiée</h3>
                <p className="text-sm text-gray-200">5+ années d'expérience, 95% de taux de satisfaction, certifications internationales</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name="Zap" size={24} className="text-white" />
                </div>
                <h3 className="font-bold mb-2">Intervention Rapide</h3>
                <p className="text-sm text-gray-200">Réponse sous 24h, diagnostic gratuit, intervention d'urgence possible</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name="Shield" size={24} className="text-white" />
                </div>
                <h3 className="font-bold mb-2">Garantie Résultats</h3>
                <p className="text-sm text-gray-200">Accompagnement jusqu'à la transformation complète de votre organisation</p>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                className="bg-white hover:bg-gray-100 px-8 py-4 rounded-xl font-semibold shadow-lg transition-all duration-200"
                style={{color: '#96121D'}}
                onClick={() => window.location.href = '/our-team'}
              >
                <div className="flex items-center space-x-2">
                  <Icon name="Users" size={20} />
                  <span>Découvrir Notre Équipe</span>
                </div>
              </Button>
              
              <Button
                variant="outline"
                size="lg"
                className="border-2 border-white text-white hover:bg-white/10 px-8 py-4 rounded-xl font-semibold transition-all duration-200"
                onClick={() => window.open('tel:+12409784155', '_self')}
              >
                <div className="flex items-center space-x-2">
                  <Icon name="Phone" size={20} />
                  <span>Urgence : +1 (240) 978-4155</span>
                </div>
              </Button>
            </div>
          </div>
        </div>

        {/* Contact Info Card */}
        <div className="mt-8 bg-white rounded-2xl shadow-lg p-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div>
              <Icon name="MapPin" size={24} className="mx-auto mb-2" style={{color: '#96121D'}} />
              <h4 className="font-semibold text-gray-900 mb-1">Adresse</h4>
              <p className="text-sm text-gray-600">Washington D.C., USA</p>
            </div>
            <div>
              <Icon name="Phone" size={24} className="mx-auto mb-2" style={{color: '#96121D'}} />
              <h4 className="font-semibold text-gray-900 mb-1">Téléphone</h4>
              <p className="text-sm text-gray-600">+1 (240) 978-4155</p>
            </div>
            <div>
              <Icon name="Mail" size={24} className="mx-auto mb-2" style={{color: '#96121D'}} />
              <h4 className="font-semibold text-gray-900 mb-1">Email</h4>
              <p className="text-sm text-gray-600">contact@crfperfection.pro</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ServiceRequestForm;